import { axiosInstance } from '../../axios/axiosInstance';

export const urls = {
  createSession: '/api/auth/member/yoti/create-session'
};

export type YotiVerificationMethod = 'selfie' | 'credit_card' | 'doc_scan';

export interface StartYotiSessionInput {
  user_id: number | string;
  hash: string;
  method?: YotiVerificationMethod;
}

export interface StartYotiSessionResponse {
  session_id: string;
  expires_at: string;
  verification_url: string;
}

export const startYotiSession = async (
  data: StartYotiSessionInput
): Promise<StartYotiSessionResponse> => {
  const response = await axiosInstance.post<StartYotiSessionResponse>(urls.createSession, data);
  return response.data;
};
